export const LANGUAGES: string[] = [
  'fr',
  'en'
];
